import ValueObject from "../../../../../frontend/ValueObject";
import {Pricing} from "./Pricing";

export interface ArrangementOptionProps {
    title: string,
    subtitle?: string,
    discount: any,
    sales: null,
    sold_out: boolean,
    alerts: any,
    is_purchasable: boolean,
    has_availability: boolean,
    is_not_available_on_date?: boolean
    multi_tab_name: string,
    pills?: any[],
    pricing?: Pricing,
    stats: {
        discount: string,
        sales: string
    },
    multi_deal_description: string,
    unique: string
}

export class ArrangementOption extends ValueObject<ArrangementOptionProps> {
    get title() {
        return this._props.title;
    }

    get subtitle() {
        return this._props.subtitle
    }

    get tab() {
        return this._props.multi_tab_name;
    }

    get pricing(): Pricing | undefined {
        return this._props.pricing;
    }

    get stats(): any {
        return this._props.stats;
    }

    get pills(): any {
        return this._props.pills;
    }

    get unique(): any {
        return this._props.unique;
    }

    get alerts(): Array<any> {
        return this._props.alerts;
    }

    get isPurchasable() {
        return this._props.is_purchasable && this._props.has_availability !== false;
    }

    static create(props: any) {
        return new ArrangementOption(Object.assign(props, {
                subtitle: props.subtitle ?? null,
                pricing: Pricing.create(props.pricing),
                pills: props.pills?.map((pill: any) => {
                    return pill;
                })
            }
        ));
    }
}
